import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { validEvents } from '@tinymce/tinymce-angular/editor/Events';
import { CustomValidators } from 'ng2-validation';
import { CityService } from 'src/app/manage/city/service/city.service';
import { CountryService } from 'src/app/manage/country/service/country.service';
import { StateService } from 'src/app/manage/state/service/state.service';
import { AcademyprofileService } from 'src/app/services/academyprofile.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { environment } from 'src/environments/environment';
import { formatDate } from '@angular/common'
import { ConfirmationService, MessageService } from 'primeng/api';
import { UserService } from 'src/app/services/user.service';
import { MustMatch } from 'src/app/_helpers/must-match.validator';

@Component({
  selector: 'app-academies-profile-edit',
  templateUrl: './academies-profile-edit.component.html',
  styleUrls: ['./academies-profile-edit.component.scss'],
  providers: [ConfirmationService, MessageService]
})
export class AcademiesProfileEditComponent implements OnInit {
  academyform: FormGroup;
  addressform: FormGroup;
  passwordform: FormGroup;
  submittedProfile = false;
  submittedAddress = false;
  submittedPassword = false;
  password = false;
  uploadedFiles: any[] = [];
  uploadedPdfFiles: any[] =[];
  public countrylist: any[] = [];
  errorMessage = '';
  public stateList: any[] = [];
  public cityList: any[] = [];
  academypic: any;
  academyschedule: any;
  public loading: boolean;
  public countryName;
  public countryCode;
  public stateName;
  public stateCode;
  public cityName;
  public cityCode;
  loggedInAcademy;
  loggedInAcademyId;
  enduserid: any;
  imageSize = environment.imageSize;
  item: any;
  disabled = true;
  profileimage: any;
  imagedata: any;
  ImagesArray: any;
  pdfArray: any;
  cityname: any;
  showPdf: boolean;
  feepdfpath:string;
  selectedDays: any[];
  weekdays: any[] = [{name: 'Sunday', key: 'sunday'}, {name: 'Monday', key: 'monday'}, {name: 'Tuesday', key: 'tuesday'}, {name: 'Wednesday', key: 'wednesday'}, {name: 'Thursday', key: 'thursday'}, {name: 'Friday', key: 'friday'}, {name: 'Saturday', key: 'saturday'}];

  checked: boolean = false;
  constructor(private formBuilder: FormBuilder, private countryService: CountryService, private stateService: StateService, private cityService: CityService, private tokenStorage: TokenStorageService, private profileservice: AcademyprofileService, private messageService: MessageService, private router: Router, private userservice: UserService
  ) { }

  ngOnInit() {
    this.loggedInAcademy = this.tokenStorage.getUser();
    this.loggedInAcademyId = this.loggedInAcademy.userdata['academyId'];
    let academyPaymentDetails = this.loggedInAcademy.userdata.academyPaymentDetails;
    let roleName = this.loggedInAcademy.userdata.rolename;
    let currentUrl = '/';
    if (roleName == "academy") {
      if (Object.keys(academyPaymentDetails).length > 0) {
        if (academyPaymentDetails.academyPaymentStatus == 'created') {
          currentUrl = '/payment-history';
          this.router.routeReuseStrategy.shouldReuseRoute = () => false;
          this.router.onSameUrlNavigation = 'reload';
          this.router.navigate([currentUrl]);
        }
      } else {
        currentUrl = '/payment-history';
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      }
    }

    this.getacademydetails(this.loggedInAcademyId);
    this.getCountries();
    this.academyform = this.formBuilder.group({
      academyname: ['', [Validators.required, Validators.pattern("([a-zA-Z',.-_]+( [a-zA-Z',.-_]+)*){2,30}")]],
      foundedyear: ['', [Validators.pattern("[0-9 ]{4}")]],
      mobileNumber: ['', [Validators.required, Validators.pattern("[0-9 ]{10}"), Validators.minLength(10)]],
      email: ['', [Validators.required, Validators.email, CustomValidators.email]],
      contactFirstName: ['',Validators.required],
      contactLastName: ['',Validators.required],
      contactNumber: ['',Validators.required],
      //websiteurl: [''],
      // websiteurl: ['', [CustomValidators.url]],
      websiteurl: ['', [Validators.pattern("^(http:\/\/|https:\/\/)(www)([\.]{1})([a-z0-9]+)([\.]{1})(com)(.*)")]],
      description: [''],
      //totalcourts: ['', [Validators.required]],
      //numberofplayers: ['', [Validators.required]],
      totalcoaches: [''],
      noofHard: [''],
      noofclay: [''],
      noofgrass: [''],
      sunday: [],
      monday: [],
      tuesday: [],
      wednesday: [],
      thursday: [],
      friday: [],
      saturday: [],
      beginnerMorning: [],
      beginnerEvening: [],
      intermediateMorning: [],
      intermediateEvening: [],
      advanceMorning: [],
      advanceEvening: [],
    }, { updateOn: "blur" });
    this.addressform = this.formBuilder.group({
      address: ['', [Validators.required]],
      country: ['', [Validators.required]],
      state: ['', [Validators.required]],
      city: ['', [Validators.required]],
      zipcode: ['', Validators.required]
    }, { updateOn: "blur" });
    this.passwordform = this.formBuilder.group({
      currentPassword: [''],
      password: [''],
      confirmPassword: [''],
    });
  }
  get f() {
    return this.academyform.controls;
  }
  get g() {
    return this.addressform.controls;
  }
  get h() {
    return this.passwordform.controls;
  }

  getacademydetails(id) {
    this.profileservice.getacademydetails(id).subscribe(async res => {
      this.item = res;
      this.enduserid = res.endUserId;
      this.academyform.controls.academyname.setValue(this.item.name);
      this.academyform.controls.foundedyear.setValue(this.item.foundedyear);
      this.academyform.controls.mobileNumber.setValue(this.item.mobileNumber);
      this.academyform.controls.email.setValue(this.item.email);
      this.academyform.controls.contactFirstName.setValue(this.item.firstName);
      this.academyform.controls.contactLastName.setValue(this.item.lastName);
      this.academyform.controls.contactNumber.setValue(this.item.contactNumber);
      this.academyform.controls.websiteurl.setValue(this.item.websiteurl);
      this.academyform.controls.description.setValue(this.item.description);
      //this.academyform.controls.totalcourts.setValue(this.item.totalcourts);
      //this.academyform.controls.numberofplayers.setValue(this.item.numberofplayers);
      this.academyform.controls.totalcoaches.setValue(this.item.totalcoaches);
      this.academyform.controls.noofHard.setValue(this.item.noofHard);
      this.academyform.controls.noofclay.setValue(this.item.noofclay);
      this.academyform.controls.noofgrass.setValue(this.item.noofgrass);
      this.academyform.controls.sunday.setValue(this.item.sunday);
      this.academyform.controls.monday.setValue(this.item.monday);
      this.academyform.controls.tuesday.setValue(this.item.tuesday);
      this.academyform.controls.wednesday.setValue(this.item.wednesday);
      this.academyform.controls.thursday.setValue(this.item.thursday);
      this.academyform.controls.friday.setValue(this.item.friday);
      this.academyform.controls.saturday.setValue(this.item.saturday);

      this.academyform.controls.beginnerMorning.setValue(this.item.beginnerMorning);
      this.academyform.controls.beginnerEvening.setValue(this.item.beginnerEvening);
      this.academyform.controls.intermediateMorning.setValue(this.item.intermediateMorning);
      this.academyform.controls.intermediateEvening.setValue(this.item.intermediateEvening);
      this.academyform.controls.advanceMorning.setValue(this.item.advanceMorning);
      this.academyform.controls.advanceEvening.setValue(this.item.advanceEvening);
      
      if(this.item.academyFees!==undefined){
        this.showPdf=true;
        this.feepdfpath=this.item.academyFees;
      } else {
        this.showPdf=false;
      }

      this.addressform.controls.address.setValue(this.item.address);
      // this.addressform.controls.country.setValue({ code: this.item.countrycode, name: this.item.countryname });
      // this.addressform.controls.state.setValue({ code: this.item.statecode, name: this.item.statename });
      // this.addressform.controls.city.setValue({ code: this.item.citycode, name: this.item.cityname });
      this.addressform.controls.zipcode.setValue(this.item.zipcode);
      //this.imagedata = res.academypic;
      this.profileimage = res.academypic;
      if (this.item.countryname) {
        this.countryName = this.item.countryname;
        this.getCountries();
        let countryObj = {
          value: {
            name: this.item['countryname'],
            iso2: this.item['countrycode'],
          }
        }

        this.getStates(countryObj);
      }

      if (this.item['statecode']) {
        this.stateName = this.item['statename'];
        this.cityname = this.item['cityname'];
        await this.getCities(this.item['statecode']);
        this.addressform.get('state').setValue({ name: this.item['statename'], code: this.item['statecode'] });
      }
      if (this.item['cityname']) {
        this.cityname = this.item['cityname'];
        this.addressform.get('city').setValue({ name: this.item['cityname'], code: this.item['citycode'] });
      }
      // if (this.imagedata != undefined) {
      //   this.imagedata.forEach((element) => {
      //     this.profileimage = element['image_src'];

      //   });
      // }
    })
  }
  picUploader(event) {
    this.academypic = [];
    let index = 0;
    for (let file of event.files) {
      this.uploadedFiles.push(file);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // called once readAsDataURL is completed
        if (reader.result != null) {
          this.academypic.push({ 'file': reader.result });
          index++;
          // this.academypic = reader.result;
        }
      }
    }
  }

  pdfUploader(event) {
    this.academyschedule = [];
    let index = 0;
    for (let file of event.files) {
      this.uploadedPdfFiles.push(file);
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        // called once readAsDataURL is completed
        if (reader.result != null) {
          this.academyschedule.push({ 'file': reader.result });
          index++;
        }
      }
    }
  }
  submitacademyform() {
    console.log(this.academyform);
    
    this.submittedProfile = true;
    if (this.academyform.invalid) {
      return;
    }
    this.ImagesArray = [];
    if (this.academypic != undefined) {
      this.academypic.forEach((element, index) => {
        index = index + 1;
        let academyImageAlt;
        let academyImageDefault;
        this.ImagesArray.push({ 'file': element.file, 'alt': academyImageAlt, 'default': academyImageDefault });
      });
    }
    this.pdfArray = [];
    if (this.academyschedule != undefined) {
      this.academyschedule.forEach((element, index) => {
        index = index + 1;
        let academyImageAlt;
        let academyImageDefault;
        this.pdfArray.push({ 'file': element.file, 'alt': academyImageAlt, 'default': academyImageDefault });
      });
    }
    var academydata = this.academyform.value;
    academydata['academypic'] = this.ImagesArray;
    academydata['academyFees'] = this.pdfArray;
    academydata['academyId'] = this.loggedInAcademyId;
    academydata['status'] = true;
    academydata['disable'] = false;
    academydata['sunday'] = (academydata['sunday'] ? academydata['sunday'] : false);
    academydata['monday'] = (academydata['monday'] ? academydata['monday'] : false);;
    academydata['tuesday'] = (academydata['tuesday'] ? academydata['tuesday'] : false);;
    academydata['wednesday'] = (academydata['wednesday'] ? academydata['wednesday'] : false);;
    academydata['thursday'] = (academydata['thursday'] ? academydata['thursday'] : false);;
    academydata['friday'] = (academydata['friday'] ? academydata['friday'] : false);;
    academydata['saturday'] = (academydata['saturday'] ? academydata['saturday'] : false);;

    academydata = JSON.stringify(academydata, null, 4);
    this.update(academydata)
  }
  submitaddressform() {
    this.submittedAddress = true;
    if (this.addressform.invalid) {
      return;
    }
    var academydata = this.addressform.value;
    academydata['academyId'] = this.loggedInAcademyId;
    academydata['status'] = true;
    academydata['disable'] = false;
    academydata['countrycode'] = this.countryCode;
    academydata['countryname'] = this.countryName;
    academydata['statecode'] = this.stateCode;
    academydata['statename'] = this.stateName;
    academydata['citycode'] = this.cityCode;
    academydata['cityname'] = this.cityName;
    academydata = JSON.stringify(academydata, null, 4);
    this.update(academydata);
  }

  update(academydata) {
    this.profileservice.updateAcademy(this.loggedInAcademyId, academydata).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Update Successfully', life: 6000 });
        setTimeout(() => {
          this.router.navigate(['/academies-profile']);
        }, 2000);
        this.uploadedFiles = [];
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Update failed', life: 6000 });
      })
    );
  }
  changepassword() {
    this.submittedPassword = true;
    if (this.passwordform.invalid) {
      return;
    }
    var passworddata = this.passwordform.value;
    passworddata = JSON.stringify(passworddata, null, 4);
    this.updatepassword(passworddata);
  }
  updatepassword(passworddata) {
    this.userservice.updateUser(this.enduserid, passworddata).subscribe(
      () => {
        this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Password Updated Successfully', life: 6000 });
        setTimeout(() => {
          this.router.navigate(['/academies-profile']);
        }, 2000);
        this.uploadedFiles = [];
      },
      ((err) => {
        this.messageService.add({ key: 'toastmsg', severity: 'error', summary: err.error.message, detail: 'Password Update failed', life: 6000 });
      })
    );
  }
  getCountries() {
    let query = "filterByDisable=false&filterByStatus=true&orderBy=name&sortBy=1";
    this.countryService.getcountryList(query).subscribe(
      data => {
        if (data.data.items.length > 0) {
          data.data.items.forEach(element => {
            let countryObj = {
              name: element.name,
              iso2: element.iso2,
            }
            this.countrylist.push(countryObj);
          });
          this.countrylist.forEach(cElement => {
            if (cElement.name === this.countryName) {
              this.addressform.get('country').setValue({ name: cElement['name'], iso2: cElement['iso2'] });
            }
          });
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }
  getStates(event) {
    this.countryName = event.value.name;
    this.countryCode = event.value.iso2;
    let query = "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" + this.countryCode;
    this.stateService.getstateList(query).subscribe((res) => {
      this.loading = false;
      if (res.data.items.length > 0) {
        res.data.items.forEach(element => {
          let stateObj = {
            name: element.name,
            id: element.id,
          }
          this.stateList.push(stateObj);
        });
        this.stateList.forEach(sElement => {
          if (sElement.name === this.stateName) {
            this.addressform.get('state').setValue({ name: sElement['name'], id: sElement['id'] });
          }
        });
      }
    })
  }
  setState(event) {
    this.stateCode = event.value.id;
    this.stateName = event.value.name;
    this.getCities(this.stateCode);
  }
  getCities(stateId) {
    this.cityList =[];
    let query = "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" + stateId;
    this.cityService.getcityList(query).subscribe((res) => {
      this.loading = false;
      if (res.data.items.length > 0) {
        res.data.items.forEach(element => {
          let cityObj = {
            name: element.name,
            code: element.name,
          }
          this.cityList.push(cityObj);
        });
        this.cityList.forEach(cElement => {
          if (cElement.name === this.cityname) {
            this.addressform.get('city').setValue({ name: cElement['name'], code: cElement['code'] });
          }
        });
      }
    })
  }
  onCitySelect(event) {
    this.cityCode = event.value.code;
    this.cityName = event.value.name;
  }
}
